export default __webpack_public_path__ + "static/media/img4.0cd3043f.PNG";